<template>
  <div class="content">

    <b-container fluid class="mt-4">

      <stats-card title="Organisations" type="default" sub-title="All orgs" icon="fas fa-sitemap">

        <template slot="actions">
            <a class="dropdown-item" href="javascript:void(0)" @click="handleOrganisationCreate">Create new</a>
        </template>

        <template slot="append">

          <base-alert>
            Last 10 orgs created displayed here. Use the search bar below to fetch more.
          </base-alert>

          <div class="mt-4">
            <entity-picker v-if="orgsData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                rootProp="organisations"
                apiEndpoint="getOrgs"
                :cursorData="cursorData"
                :selected="orgsData"
                :filters="tableFilters"
                :tableOptions="tableOptions"
                :tableColumns="tableColumns"
                editPath="/organisations/"
            >
            </entity-picker>
          </div>
      </template>
      </stats-card>
    </b-container>

    <modal :show.sync="showCreateModal">
        <h6 slot="header" class="modal-title">Add new Organisation</h6>

      <base-input label="Organisation name:" v-model="newOrg.name"></base-input>
      <base-input label="Contact email:" v-model="newOrg.email"></base-input>
      <base-input label="Contact phone:" v-model="newOrg.phone"></base-input>

        <div class="form-check">
            <input type="checkbox" v-model="createDefault" class="form-check-input" checked="checked" id="createDefault">
            <label class="form-check-label" for="createDefault"><small>Create default farm / orchard</small></label>
        </div>

        <template slot="footer">
            <base-button type="blank" @click="showCreateModal = false">Cancel</base-button>
            <base-button :disabled="!(newOrg.name && newOrg.name.length >= 5 && newOrg.email && newOrg.phone)" type="success" @click="createNewOrg">Create Org</base-button>
        </template>
    </modal>


  </div>
</template>


<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/OrganisationsTable'
import { OrganisationModel } from '../models/organisation/organisation';

export default {
  components: {
  },
  data() {
    return {
      orgsData: [],
      newOrg: new OrganisationModel(),
      newOrgName: '',
      showCreateModal: false,
      createDefault: true,
      cursorData: null,
      tableFilters: tableFilters,
      tableColumns: tableColumns,
      tableOptions: tableOptions
    };
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getOrgs({
      sort: this.tableOptions['default-sort'].prop,
      direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
      limit: this.tableOptions.limit
    })
    this.$emit('loading', false);
    this.orgsData = results.organisations;
    this.cursorData = results.cursor
  },
  methods: {
    createNewOrg: async function() {

      this.$emit('loading', true);
      const results = await api.createOrg(this.newOrg.exportToCreate({defaults: { create: this.createDefault } }));
      this.$emit('loading', false);

      if (results) {
        this.showCreateModal = false;
        this.$router.push(`/organisations/${results.id}${results && results.farm && results.orchard ? '?created' : ''}`);
        this.$emit('onApiResult', 'Org created, redirecting you to it...')
      }
    },
    handleOrganisationCreate() {
      this.$router.push({ path: 'organisations/new' })
    }
  }
};
</script>
